<template>
  <div class="p-processing">
    <card
      :show-header="false"
      class="card_max-xs"
    >
      <div class="d-flex align-center">
        <v-icon class="p-processing__icon" size="50" color="primary">mdi-loading</v-icon>
        <div style="font-size: 20px;" class="ml-4">{{ $t('msg.processingPayment') }}</div>
      </div>
    </card>
  </div>
</template>

<script>
import Card from "@/components/ui/Card";

export default {
  components: {Card},
  methods: {
    getSuccessPath() {
      let props = this.$router.resolve({
        name: 'billing_success',
      });

      return props.href;
    },
    processing() {
      this.$store.dispatch('loadProfile', {params: {}})
        .then(res => {

          if (res.is_paid) {
            window.location = this.getSuccessPath();
            return;
          }

          setTimeout(() => {
            this.processing();
          }, 5000)
        })
    }
  },
  created() {
    this.processing();
  }
}
</script>

<style lang="scss">
.p-processing {
  .p-processing__icon {
    animation: rotation 1s linear infinite;
  }
}
</style>